<template>
  <div>
    <page-title
      heading="Antrean Pasien"
      :breadcrumb="[
        {
          label: 'Manajemen Antrean',
          link: '/antrean-klinik'
        },
        {
          label: 'List Antrean',
          active: true
        }
      ]"
      class="antrean"
    />

    <div class="container-fluid __zoom_display_antrean">
      <div class="card card-box mb-3 ninja-shadow">
        <div class="card-body">
          <b-row>
            <b-col md="12">
              <div class="time-dimention">
                <b-button-group>
                  <b-button
                    :class="{ active__time: isTab == 'today' }"
                    @click="isTab = 'today'"
                    class="btn-today"
                    variant="outline-dark"
                    >Hari Ini ({{ rowToday }})</b-button
                  >
                  <b-button
                    :class="{ active__time: isTab == 'prev' }"
                    @click="isTab = 'prev'"
                    class="btn-next"
                    variant="outline-dark"
                  >
                    Kunjungan Sebelumnya ({{ rowPrevDay }})
                    <font-awesome-icon
                      icon="info-circle"
                      class="ml-2"
                      v-tooltip="{
                        placement: 'top',
                        classes: 'info-tooltip',
                        content: `Daftar kunjungan pasien sebelumnya dengan <br/> 
                        masa edit rekam medis 2x24 jam dari waktu konsultasi`
                      }"
                    >
                    </font-awesome-icon>
                  </b-button>
                  <b-button
                    :class="{ active__time: isTab == 'next' }"
                    @click="isTab = 'next'"
                    class="btn-next"
                    variant="outline-dark"
                    >Akan Datang ({{ rowNextDay }})</b-button
                  >
                </b-button-group>
              </div>
            </b-col>
          </b-row>
          <b-row class="my-4">
            <b-col :cols="isMobilePortrait() ? 12 : 9">
              <div
                v-if="isTab == 'today' && hasFeatures('edit_rm') && this.checkValueData(this.pemanggilanAntrean)"
                class="row"
                :class="isScreenNoCollapsed() || isMobilePortrait() ? '' : 'pr-4'"
              >
                <div class="media media-info" :class="mediaInfoClass()">
                  <img src="/img/jumlah-antrean.png" alt="jumlah antrean" class="ml-2 pt-2" width="50">
                  <div class="media-body pl-3">
                    <h3 class="mt-0 text-600 fc-jumlah-antrean">{{ antrean.total || 0 }}</h3>
                    <span class="fs-7-5">Jumlah Antrean</span>
                  </div>
                </div>
                <div class="media media-info" :class="mediaInfoClass()">
                  <img src="/img/antrean-sekarang.png" alt="antrean sekarang" class="ml-2 pt-2" width="50">
                  <div class="media-body pl-3">
                    <h3 class="mt-0 text-600 fc-antrean-sekarang">{{ antrean.now || '-' }}</h3>
                    <span class="fs-7-5">No. Antrean Sekarang</span>
                  </div>
                </div>
                <div class="media media-info" :class="mediaInfoClass()">
                  <img src="/img/antrean-selanjutnya.png" alt="antrean selanjutnya" class="ml-2 pt-2" width="50">
                  <div class="media-body pl-3">
                    <h3 class="mt-0 text-600 fc-antrean-selanjutnya">{{ antrean.next || '-' }}</h3>
                    <span class="fs-7-5">No. Antrean Selanjutnya</span>
                  </div>
                </div>
                <div class="media media-info" :class="mediaInfoClass()">
                  <img src="/img/sisa-antrean.png" alt="sisa antrean" class="ml-2 pt-2" width="40">
                  <div class="media-body pl-3">
                    <h3 class="mt-0 text-600 fc-sisa-antrean">{{ antrean.remaining || 0 }}</h3>
                    <span class="fs-7-5">Sisa Antrean</span>
                  </div>
                </div>
              </div>
              <div v-else-if="isTab == 'today'" class="desc-antrean">
                <div class="desc-left">
                  <span class="lb-total">Total Antrean Pasien: </span>
                  <span class="nb-total">{{ totalFilter }}</span>
                </div>
              </div>
            </b-col>
            <b-col
              :cols="isMobilePortrait() ? 12 : 3"
              :class="isMobilePortrait() ? '' : 'd-flex align-self-center justify-content-end'"
            >
              <b-button
                variant="primary"
                v-if="hasFeatures('tambah_antrean')"
                class="text-uppercase"
                :class="isMobilePortrait() ? 'my-3 width-100' : ''"
                :to="{
                  name: 'antrean-klinik-tambah'
                }"
                >tambah antrean</b-button
              >
            </b-col>
          </b-row>
          <div class="stright-line"></div>
          <b-row class="head-filter" v-if="isTab != 'prev'">
            <b-col sm="12" md="3" lg="2" class="mt-2" v-if="isTab == 'next'">
              <label style="margin-bottom:15px;">Hari, Tanggal</label>
              <date-picker
                v-model="date"
                type="date"
                format="DD-MM-YYYY"
                value-type="YYYY-MM-DD"
                :disabled-date="disabledDate"
                placeholder="DD-MM-YYYY"
                :style="'width: 100%'"
              >
              </date-picker>
            </b-col>
            <b-col sm="12" md="3" lg="2" class="mt-2">
              <label class="lb-header-filter">Poliklinik</label>
              <vue-select-clearable
                :options="optionPoli"
                v-model="poli_id"
                :placeholder="'Semua Poli'"
                @input="additionalFilter('poli')"
                class="custom-v-select-header-antrean mt-2"
                style="width:100%;background-color:#ffffff;"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option.label }}
                </template>
              </vue-select-clearable>
            </b-col>
            <b-col sm="12" md="3" lg="2" class="mt-2" v-if="!onlyDokter()">
              <label class="lb-header-filter">Dokter</label>
              <vue-select-clearable
                :options="optionDokter"
                v-model="dokter_id"
                :disabled="poli_id == null"
                @input="additionalFilter('dokter')"
                :placeholder="'Semua Dokter'"
                class="custom-v-select-header-filter mt-2"
                style="width:100%;background-color:#ffffff;"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option.label }}
                </template>
              </vue-select-clearable>
            </b-col>
            <b-col sm="12" md="3" lg="2" class="mt-2">
              <label class="lb-header-filter">Kategori Pasien</label>
              <vue-select-clearable
                :options="optionKategoriPasien"
                v-model="kategori_id"
                :disabled="poli_id == null"
                :placeholder="'Semua Kategori'"
                @input="additionalFilter('pasien')"
                class="custom-v-select-header-filter mt-2"
                style="width:100%;background-color:#ffffff;"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option.label }}
                </template>
              </vue-select-clearable>
            </b-col>
            <b-col sm="12" md="3" lg="2" class="mt-2" v-if="isTab == 'today'">
              <label class="lb-header-filter">Status</label>
              <vue-select-clearable
                :options="optionStatus"
                v-model="status_id"
                :disabled="poli_id == null"
                :placeholder="'Semua Status'"
                @input="additionalFilter('status')"
                class="custom-v-select-header-filter mt-2"
                style="width:100%;background-color:#ffffff;"
              >
                <template slot="option" slot-scope="option">
                  {{ option }}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option }}
                </template>
              </vue-select-clearable>
            </b-col>
          </b-row>
          <div class="stright-line-none"></div>
          <div class="col-md-12 no-padding">
            <!-- :custom-row="customRow" -->
            <DataTableWrapper
              :perPage="perPage"
              :fromPage="fromPage"
              :toPage="toPage"
              :totalEntries="totalEntries"
              :currentPage="currentPage"
              :callbackFunc="fetchListAntrean"
              :customEntryOptions="customEntryOptions"
              @valueChanged="handleValueChanged"
            >
              <div
                id="antrean-table"
                class="table-responsive"
                style="min-height: 375px; overflow: scroll hidden;"
              >
                <b-table
                  v-if="tableShow"
                  :items="antreanList"
                  :fields="fieldList"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  thead-tr-class="izd-datatable"
                  :no-local-sorting="true"
                  class="sticky-header-antrean"
                >
                  <!-- HEADER SLOT -->
                  <template v-slot:head()="data">
                    {{ data.label }}
                    <b-input
                      size="sm"
                      class="mt-2 w-95"
                      v-if="data.field.searchable"
                      @input="searchValueChanged($event, data.field.key)"
                    />
                  </template>

                  <template v-slot:head(nomor_urut_bpjs)="data">
                    {{ data.label }}
                    <font-awesome-layers
                      style="font-size: 1rem;"
                      v-tooltip="{
                        placement: 'right',
                        classes: 'info-tooltip',
                        content: `
                          No urut ini disesuaikan dengan waktu registrasi antrean.
                          Berlaku untuk general Faskes dan Faskes yang sudah melakukan bridging BPJS.
                          Sehingga no urut ini berlaku untuk semua kategori pasien, baik yang datang onsite maupun dari mobile JKN`
                      }"
                    >
                      <font-awesome-icon
                        :icon="['far', 'circle']"
                        class="color-info pointer"
                      />
                      <font-awesome-icon
                        :icon="['fas', 'info']"
                        style="font-size: .5rem;"
                        class="color-info pointer"
                      />
                    </font-awesome-layers>
                    <b-input
                      size="sm"
                      class="mt-2 w-95"
                      v-if="data.field.searchable"
                      @input="searchValueChanged($event, data.field.key)"
                    />
                  </template>

                  <template v-slot:head(nama_sumber)="data">
                    {{ data.label }}
                    <select
                      class="form-control select-status"
                      @input="
                        searchValueChanged($event.target.value, data.field.key)
                      "
                    >
                      <option value="">Semua</option>
                      <option value="0">On Site</option>
                      <option value="1">Mobile JKN</option>
                    </select>
                  </template>

                  <template v-slot:cell()="data">
                    {{ data.value }}
                  </template>

                  <template v-slot:cell(slot)="data">
                    <template v-if="data.item.jkn_is_edited == 0">
                      <span
                        v-tooltip="{
                          content: `Harap mengisi slot konsultasi.</br>Silakan pilih di action Edit Detail Antrean.`
                        }"
                        :style="{
                          marginLeft: '50%'
                        }"
                      >
                        <font-awesome-icon
                          class="align-middle"
                          style="color: #33bdff; padding: 5px; font-size:2.3em; margin-top: -5px"
                          icon="info-circle"
                        />
                      </span>
                    </template>
                    <template v-else>
                      {{ data.value }}
                    </template>
                  </template>

                  <template v-slot:cell(nama_dokter)="data">
                    <template v-if="data.value">
                      {{ data.value }}
                    </template>
                    <template v-else>
                      <span
                        v-tooltip="{
                          content: `Harap mengisi nama Dokter.</br>Silakan pilih di action Edit Detail Antrean.`
                        }"
                        :style="{
                          marginLeft: '50%'
                        }"
                      >
                        <font-awesome-icon
                          class="align-middle"
                          style="color: #33bdff; padding: 5px; font-size:2.3em; margin-top: -5px"
                          icon="info-circle"
                        />
                      </span>
                    </template>
                  </template>

                  <template v-slot:head(action)="data">
                    <span class="mt-2">{{ data.label }}</span>
                  </template>

                  <template v-slot:head(poliklinik)="data">
                    {{ data.label }}

                    <template>
                      <multiselect
                        class="__multi-select-tarif mt-2"
                        v-model="selectedPoli"
                        placeholder="Pilih Poli"
                        :options="optionPoli"
                        :multiple="true"
                        label="label"
                        @input="clearPoli($event)"
                        open-direction="bottom"
                        track-by="label"
                        selectLabel=""
                        deselectLabel="x"
                        selectedLabel="Terpilih"
                        :preselect-first="true"
                        :close-on-select="true"
                        :clear-on-select="true"
                      >
                        <template
                          slot="selection"
                          slot-scope="{ values, isOpen }"
                          ><span
                            :style="'font-size:10pt'"
                            v-if="values.length &amp;&amp; !isOpen"
                            >{{ values.length }} Terpilih</span
                          ></template
                        >
                      </multiselect>
                    </template>
                  </template>

                  <template v-slot:head(kategori)="data">
                    {{ data.label }}
                    <template>
                      <vue-select-clearable
                        :options="optionKategori"
                        v-model="selectedKategori"
                        @input="clearKategori($event)"
                        class="custom-v-select-manajemen-tarif mt-2"
                        style="width:100%;background-color:#ffffff;"
                      >
                        <template slot="option" slot-scope="option">
                          {{ option.label }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          {{ option.label }}
                        </template>
                      </vue-select-clearable>
                    </template>
                  </template>

                  <!-- CELL SLOT -->
                  <template v-slot:cell(nomor_rekam_medis)="data">
                    <div class="align-center">
                      {{ data.value }}
                      <span
                        v-if="
                          data.item.nomor_rekam_medis_manual !== null &&
                            data.item.nomor_rekam_medis_manual !== ''
                        "
                        :id="'rm-manual-' + data.item.id"
                        v-tooltip="{
                          content: `<strong>NO.RM MANUAL</strong><br/>${data.item.nomor_rekam_medis_manual}`,
                          classess: 'rm-manual'
                        }"
                      >
                        <font-awesome-icon
                          class="align-middle"
                          style="color: #33bdff; padding: 5px; font-size:2.3em; margin-top: -5px"
                          icon="clipboard-list"
                        />
                      </span>
                    </div>
                  </template>

                  <template v-slot:cell(nama_pasien)="data">
                    <div class="media">
                      <div
                        v-if="data.value.length > 24"
                        class="media-body"
                        :id="'nama_pasien-' + data.item.id"
                        v-tooltip="{
                          content: `${data.value}`,
                          classes: 'satusehat-tooltip'
                        }"
                      >
                        {{ data.value.substring(0, 24) + "..." }}
                      </div>
                      <div v-else class="media-body">{{ data.value }}</div>
                      <span
                        v-if="checkSyncSatuSehat(data.item) == 'success'"
                        :id="'success-' + data.item.id"
                        v-tooltip="{
                          content: `Berhasil Sinkronisasi Dengan SatuSehat`,
                          classes: 'satusehat-tooltip'
                        }"
                      >
                        <img
                          src="/img/satusehat-aktif.png"
                          class="icon_sync_bpjs"
                        />
                      </span>
                      <span
                        v-if="checkSyncSatuSehat(data.item) == 'failed'"
                        :id="'failed-' + data.item.id"
                        v-tooltip="{
                          content: `Gagal Sinkronisasi Dengan SatuSehat`,
                          classes: 'satusehat-tooltip'
                        }"
                      >
                        <img
                          src="/img/satusehat-blm-aktif100x100.png"
                          class="icon_sync_bpjs"
                        />
                      </span>
                      <span
                        v-if="
                          data.item.nama_kategori == 'BPJS' &&
                            data.item.synced_to_bpjs &&
                            [2, 3, 4, 5].includes(data.item.synced_to_bpjs) &&
                            bpjsAuthValid
                        "
                        :id="'failed-bpjs' + data.item.id"
                        v-tooltip="{
                          content: bpjsTooltipInvalidMessage(
                            data.item.synced_to_bpjs
                          ),
                          classes: 'satusehat-tooltip'
                        }"
                      >
                        <img
                          src="/img/bpjs-blum-aktif.png"
                          class="icon_sync_bpjs"
                        />
                      </span>

                      <span
                        v-if="
                          data.item.nama_kategori == 'BPJS' &&
                            data.item.synced_to_bpjs &&
                            data.item.synced_to_bpjs == 1 &&
                            bpjsAuthValid
                        "
                        :id="'failed-bpjs' + data.item.id"
                        v-tooltip="{
                          content: `Berhasil Sinkronisasi Dengan BPJS`,
                          classes: 'satusehat-tooltip'
                        }"
                      >
                        <img src="/img/bpjs-aktif.png" class="icon_sync_bpjs" />
                      </span>
                    </div>
                  </template>

                  <template v-slot:cell(action)="data">
                    <span
                      class="d-flex align-items-center justify-content-between"
                    >
                      <b-dropdown
                        id="dropdown-1"
                        class="m-md-2 text-capitalize"
                        variant="primary"
                        size="sm"
                        right
                      >
                        <template v-slot:button-content>
                          <font-awesome-icon icon="copy" />
                        </template>
                        <b-dropdown-item
                          class="d-none"
                          v-if="
                            data.item.nama_kategori == 'BPJS' &&
                              data.item.nama_sumber != 'Mobile JKN'
                          "
                          >&nbsp;</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-if="
                            hasFeatures('edit_antrean') && isTab != 'next'
                              ? hasTodayAction(
                                  data.item.status,
                                  'edit_detail_antrean'
                                )
                              : hasNextAction('edit_detail_antrean')
                          "
                          :to="{
                            name: 'antrean-klinik-edit',
                            params: {
                              id: data.item.id
                            }
                          }"
                        >
                          Edit Detail Antrean
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="
                            isTab != 'next'
                              ? hasTodayAction(
                                  data.item.status,
                                  'detail_registrasi_antrean'
                                )
                              : hasNextAction('detail_registrasi_antrean')
                          "
                          @click="showDetailAntrean(data.item)"
                        >
                          Detail Registrasi Antrean
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="
                            hasFeatures('delete_antrean') && isTab != 'next'
                              ? hasTodayAction(
                                  data.item.status,
                                  'batal_konsultasi'
                                )
                              : hasNextAction('batal_konsultasi')
                          "
                          @click="
                            pembatalanAntrean({
                              id: data.item.id,
                              namaPasien: data.item.nama_pasien,
                              kategori: data.item.nama_kategori
                            })
                          "
                        >
                          Batalkan konsultasi
                        </b-dropdown-item>
                        <!-- reschedule -->
                        <b-dropdown-item
                          @click="
                            clickReschedule(
                              data.item.id,
                              data.item.nomor_antrian,
                              data.item.nama_kategori
                            )
                          "
                          v-if="
                            hasFeatures('reschedule_antrean') &&
                            isTab == 'today'
                              ? hasTodayAction(data.item.status, 'reschedule')
                              : hasNextAction('reschedule')
                          "
                        >
                          Reschedule
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="
                            hasFeatures('tulis_rm') &&
                              isTab != 'next' &&
                              data.item.is_access_data &&
                              hasTodayAction(data.item.status, 'tulis_rm')
                              && data.item.jkn_is_edited != 0
                          "
                          @click="goToRekamMedis(data.item, 'tulis_rm')"
                        >
                          Tulis Rekam Medis
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="
                            hasFeatures('edit_rm') &&
                              isTab != 'next' &&
                              data.item.is_access_data &&
                              hasTodayAction(data.item.status, 'edit_rm')
                          "
                          @click="goToRekamMedis(data.item, 'edit_rm')"
                        >
                          Edit Rekam Medis
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="
                            hasFeatures('lihat_rm') && isTab != 'next'
                              ? hasTodayAction(data.item.status, 'lihat_rm')
                              : hasNextAction('lihat_rm')
                          "
                          @click="goToRiwayatRekamMedis(data.item.pasien_id)"
                        >
                          Lihat Rekam Medis
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="
                            checkSyncSatuSehat(data.item) == 'failed' ||
                              (data.item.nama_kategori == 'BPJS' && bpjsAuthValid && [1,3].includes(data.item.synced_to_bpjs))
                          "
                          @click="syncSatuSehat(data.item)"
                        >
                          Sinkronisasi Ulang
                        </b-dropdown-item>
                        <b-dropdown-item
                          v-if="
                            hasFeatures('reschedule_antrean') && isTab == 'today'
                          "
                          @click="cetakNomorAntrean(data.item.id)"
                        >
                          Cetak Nomor Antrean
                        </b-dropdown-item>
                      </b-dropdown>
                    </span>
                  </template>

                  <template v-slot:cell(status)="data">
                    <template v-if="data.item.status == 'KONSULTASI'">
                      <div class="__card-blue">
                        <center>
                          <strong
                            class="text-uppercase "
                            style="color:white;font-size:12px"
                            >{{ data.value }}</strong
                          >
                        </center>
                      </div>
                    </template>
                    <template v-else-if="data.item.status == 'SELESAI'">
                      <div class="__card-green">
                        <center>
                          <strong
                            class="text-uppercase "
                            style="color:white;font-size:12px"
                            >{{ data.value }}</strong
                          >
                        </center>
                      </div>
                    </template>
                    <template v-else-if="data.item.status == 'MENUNGGU'">
                      <div class="__card-coklat">
                        <center>
                          <strong
                            class="text-uppercase "
                            style="color:white;font-size:12px"
                            >{{ data.value }}</strong
                          >
                        </center>
                      </div>
                    </template>
                    <template v-else-if="data.item.status == 'BATAL'">
                      <div class="__card-red">
                        <center>
                          <strong
                            class="text-uppercase "
                            style="color:white;font-size:12px"
                            >{{ data.value }}</strong
                          >
                        </center>
                      </div>
                    </template>
                  </template>
                  <template v-slot:cell(last_modified)="data">
                    <label style="font-size:13px;">
                      {{ formatLastModified(data.item.updated.at) }} <br />
                      by <b>{{ data.item.updated.by || "-" }}</b>
                    </label>
                  </template>
                  <template v-slot:cell(panggil_antrean)="data">
                    <div class="text-center borderleft">
                      <button
                        v-if="
                          isTab != 'next' &&
                          data.item.is_access_data &&
                          (hasTodayAction(data.item.status, 'tulis_rm') || hasTodayAction(data.item.status, 'edit_rm'))
                        "
                        class="btn rounded-50 px-2 py-1"
                        :class="panggilStatus(data.item.status) ? 'btn-selesai-panggil' : 'btn-panggil'"
                        @click="panggilAntrean(data.item.id, data.item.status)"
                      >
                        <img src="/img/panggil.png" alt="panggil" width="15" />
                      </button>
                    </div>
                  </template>
                </b-table>
              </div>
            </DataTableWrapper>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL Reschedule -->
    <b-modal
      ref="my-modal-1"
      size="md"
      hide-footer
      hide-header
      no-close-on-esc
      no-close-on-backdrop
      content-class="shadow-none"
    >
      <b-container>
        <b-form @submit.prevent="onSubmitReschedule">
          <b-row>
            <b-col md="12 mt-3">
              <center>
                <strong
                  class="text-uppercase"
                  style="font-size:18px;color:#4b80b6 !important"
                  >reschedule jadwal</strong
                >
              </center>
            </b-col>
            <b-col md="12 mt-4">
              <b-form-group id="fieldset-1">
                <strong class="text-capitalize" style="color:#4b80b6 !important"
                  >tanggal konsultasi<span style="color:red">*</span>:</strong
                >
                <DatePickerX
                  v-model="dataTanggal"
                  :max-date="maxDate"
                  locale="id"
                  :min-date="new Date()"
                  :input-props="{
                    placeholder: 'Pilih Tanggal',
                    readonly: true
                  }"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <b-form-input
                      placeholder="Pilih Tanggal Konsultasi"
                      :value="inputValue"
                      v-on="inputEvents"
                      :readonly="true"
                      class="col-md-12 mt-2"
                      style="background-color:#ffffff;"
                      :is-required="true"
                    ></b-form-input>
                  </template>
                </DatePickerX>
                <font-awesome-icon
                  icon="calendar"
                  style="
                    float: right !important;
                    position: absolute;
                    right: 7%;
                    top: 42px;
                    color: gray;
                  "
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group id="fieldset-1">
                <strong class="text-capitalize" style="color:#4b80b6 !important"
                  >Poliklinik<span style="color:red">*</span>:</strong
                >
                <v-select
                  v-model="selectedReschedulePoli"
                  :disabled="dataTanggal == null"
                  :options="optionReschedulePoli"
                  @input="inputPoliklinik($event)"
                  class="mt-2"
                  placeholder="Pilih Poli"
                  style="height:auto !important;"
                />
                <span style="color:red" v-if="this.validatePoli"
                  >Kolom harus diisi</span
                >
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group id="fieldset-1">
                <strong class="text-capitalize" style="color:#4b80b6 !important"
                  >nama dokter<span style="color:red">*</span>:</strong
                >
                <v-select
                  :clearable="false"
                  :disabled="selectedReschedulePoli.length == 0"
                  v-model="selectedDokter"
                  :options="optionRescheduleDokter"
                  @input="inputDokter($event)"
                  class="mt-2"
                  placeholder="Pilih Dokter"
                  :selectable="option => !option.disable"
                  style="height:auto !important;"
                />
                <span style="color:red" v-if="this.validateDokter"
                  >Kolom harus diisi</span
                >
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group id="fieldset-1">
                <strong class="text-capitalize" style="color:#4b80b6 !important"
                  >slot konsultasi<span style="color:red">*</span>:</strong
                >
                <v-select
                  :disabled="selectedDokter.length == 0"
                  v-model="selectedSlot"
                  :options="optionSlot"
                  @input="inputSlot"
                  class="mt-2"
                  placeholder="Pilih Slot Waktu"
                  style="height:auto !important;"
                />
                <span style="color:red" v-if="this.validateSlot"
                  >Kolom harus diisi</span
                >
              </b-form-group>
            </b-col>

            <b-col md="12 mt-3">
              <b-button
                variant="primary"
                type="submit"
                class="text-uppercase float-right"
              >
                ubah
              </b-button>
              <b-button
                variant="danger"
                @click="closeReschedule()"
                class="text-uppercase float-right mr-3"
              >
                batal
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </b-modal>

    <!-- MODAL DETAIL ANTREAN -->
    <b-modal
      size="lg"
      v-b-modal.modal-tall
      ref="my-modal"
      title="Detail Registrasi Antrean"
      @hidden="onHiddenModalDetailHandler"
      :no-close-on-backdrop="true"
      content-class="modal_detail_antrean"
    >
      <div class="accordion mt-4" role="tablist" v-if="detailAntrean">
        <div class="data-pasien">
          <div
            class="row pointer"
            @click="visible_section_1 = !visible_section_1"
          >
            <div class="col-md font-weight-bold">
              DATA PASIEN
            </div>
            <div class="col-md text-right">
              <font-awesome-icon
                style="font-size: 24px;"
                :icon="['fas', 'chevron-down']"
                :class="{
                  'rotate-0': visible_section_1,
                  'rotate-90': !visible_section_1
                }"
              />
            </div>
          </div>
          <hr />
          <b-collapse
            id="accordion-1"
            v-model="visible_section_1"
            accordion="my-accordion"
            role="tabpanel"
          >
            <InfoRow label="Nama Pasien" :value="detailAntrean.nama" />
            <InfoRow label="Pekerjaan Pasien" :value="detailAntrean.pekerjaan" />
            <InfoRow
              label="No. Rekam Medis"
              :value="detailAntrean.pasien.nomor_rekam_medis"
            />
            <InfoRow
              label="No. Handphone"
              :value="detailAntrean.pasien.nomor_hp_prefix ? '+' + detailAntrean.pasien.nomor_hp_prefix + detailAntrean.pasien.nomor_hp : detailAntrean.pasien.nomor_hp"
            />
            <InfoRow
              label="Usia Pasien"
              :value="
                `${detailAntrean.pasien.age_year} tahun ${detailAntrean.pasien.age_month} bulan ${detailAntrean.pasien.age_day} hari`
              "
            />
            <InfoRow
              label="Jenis Kelamin"
              :value="jenisKelamin(detailAntrean.pasien.jenis_kelamin)"
            />
            <InfoRow label="Poliklinik" :value="detailAntrean.poli.nama" />
            <InfoRow label="Nama Dokter" :value="detailAntrean.dokter.nama" />
            <InfoRow label="Slot Waktu" :value="detailAntrean.slot" />
            <InfoRow
              label="Provinsi"
              :value="detailAntrean.pasien.provinsi_nama"
            />
            <InfoRow
              label="Kabupaten/Kota"
              :value="detailAntrean.pasien.kota_nama"
            />
            <InfoRow
              label="Alamat"
              :value="detailAntrean.pasien.alamat_rumah"
            />
          </b-collapse>
        </div>
        <div class="informasi-lain">
          <div
            class="row pointer"
            @click="visible_section_2 = !visible_section_2"
          >
            <div class="col-md font-weight-bold">
              INFORMASI LAINNYA
            </div>
            <div class="col-md text-right">
              <font-awesome-icon
                style="font-size: 24px;"
                :icon="['fas', 'chevron-down']"
                :class="{
                  'rotate-0': visible_section_2,
                  'rotate-90': !visible_section_2
                }"
              />
            </div>
          </div>
          <hr />
          <b-collapse
            id="accordion-2"
            v-model="visible_section_2"
            accordion="my-accordion"
            role="tabpanel"
          >
            <InfoRow
              label="Tinggi Badan"
              :value="detailAntrean.anamnesa.tinggi_badan"
            />
            <InfoRow
              label="Berat Badan"
              :value="detailAntrean.anamnesa.berat_badan"
            />
            <InfoRow
              label="Tensi Sistole"
              :value="detailAntrean.anamnesa.tensi_sistole"
            />
            <InfoRow
              label="Tensi Diastole"
              :value="detailAntrean.anamnesa.tensi_diastole"
            />
            <InfoRow label="Suhu" :value="detailAntrean.anamnesa.suhu" />
            <InfoRow label="Nadi" :value="detailAntrean.anamnesa.nadi" />
            <InfoRow
              label="Respirasi"
              :value="detailAntrean.anamnesa.respirasi"
            />
            <InfoRow
              label="Lingkar Perut"
              :value="detailAntrean.pasien.lingkar_perut"
            />
            <InfoRow label="IMT" :value="detailAntrean.anamnesa.imt" />
            <InfoRow
              label="Saturasi Oksigen"
              :value="detailAntrean.anamnesa.saturasi_oksigen"
            />
            <InfoRow
              label="Golongan Darah"
              :value="detailAntrean.anamnesa.golongan_darah"
            />
            <InfoRow label="Keluhan" :value="detailAntrean.anamnesa.keluhan" />
            <InfoRow label="Anamnesa" :value="detailAntrean.anamnesa.notes" />
          </b-collapse>
        </div>
        <div class="alergi">
          <div
            class="row pointer"
            @click="visible_section_3 = !visible_section_3"
          >
            <div class="col-md font-weight-bold">
              Alergi & Kondisi Khusus
            </div>
            <div class="col-md text-right">
              <font-awesome-icon
                style="font-size: 24px;"
                :icon="['fas', 'chevron-down']"
                :class="{
                  'rotate-0': visible_section_3,
                  'rotate-90': !visible_section_3
                }"
              />
            </div>
          </div>
          <hr />
          <b-collapse
            id="accordion-3"
            v-model="visible_section_3"
            accordion="my-accordion"
            role="tabpanel"
          >
            <InfoRow
              label="Riwayat Penyakit"
              :value="detailAntrean.anamnesa.riwayat_penyakit"
            />
            <InfoRow
              label="Riwayat Alergi Obat"
              :value="detailAntrean.anamnesa.riwayat_alergi_obat"
            />
            <InfoRow
              v-if="checkLain('obat')"
              label="Keterangan Riwayat Alergi Obat"
              :value="detailAntrean.anamnesa.ket_riwayat_alergi_obat"
            />
            <InfoRow
              label="Riwayat Alergi Makanan"
              :value="detailAntrean.anamnesa.riwayat_alergi_makanan"
            />
            <InfoRow
              v-if="checkLain('makanan')"
              label="Keterangan Riwayat Alergi Makanan"
              :value="detailAntrean.anamnesa.ket_riwayat_alergi_makanan"
            />
            <InfoRow
              label="Riwayat Alergi Udara"
              :value="detailAntrean.anamnesa.riwayat_alergi_udara"
            />
            <InfoRow
              label="Riwayat Alergi Lain-Lain"
              :value="detailAntrean.anamnesa.riwayat_alergi_lain"
            />
            <InfoRow
              label="Riwayat Pengobatan"
              :value="detailAntrean.anamnesa.riwayat_pengobatan"
            />
            <InfoRow
              label="Keterangan Lain"
              :value="detailAntrean.pasien.keterangan_lain"
            />
          </b-collapse>
        </div>
        <div class="riwayat_kesehatan" v-show="isPoliGigi">
          <div
            class="row pointer"
            @click="visible_section_4 = !visible_section_4"
          >
            <div class="col-md font-weight-bold">
              Riwayat Kesehatan
            </div>
            <div class="col-md text-right">
              <font-awesome-icon
                style="font-size: 24px;"
                :icon="['fas', 'chevron-down']"
                :class="{
                  'rotate-0': visible_section_4,
                  'rotate-90': !visible_section_4
                }"
              />
            </div>
          </div>
          <hr />
          <b-collapse
            id="accordion-4"
            v-model="visible_section_4"
            accordion="my-accordion"
            role="tabpanel"
          >
            <InfoRow
              label="Penyakit Jantung"
              :value="valueDiagnosa('penyakit_jantung')"
            />
            <InfoRow label="Diabetes" :value="valueDiagnosa('diabetes')" />
            <InfoRow label="Haemopilia" :value="valueDiagnosa('haemopilia')" />
            <InfoRow label="Hepatitis" :value="valueDiagnosa('hepatitis')" />
            <InfoRow label="Gastring" :value="valueDiagnosa('gastring')" />
            <InfoRow
              label="Penyakit Lainnya"
              :value="valueDiagnosa('penyakit_lainnya')"
            />
          </b-collapse>
        </div>
        <div class="pemeriksaan-fisik">
          <div
            class="row pointer"
            @click="visible_section_5 = !visible_section_5"
          >
            <div class="col-md font-weight-bold">
              Pemeriksaan Fisik
            </div>
            <div class="col-md text-right">
              <font-awesome-icon
                style="font-size: 24px;"
                :icon="['fas', 'chevron-down']"
                :class="{
                  'rotate-0': visible_section_5,
                  'rotate-90': !visible_section_5
                }"
              />
            </div>
          </div>
          <hr />
          <b-collapse
            id="accordion-5"
            v-model="visible_section_5"
            accordion="my-accordion"
            role="tabpanel"
          >
            <InfoRow
              label="Luas Permukaan Tubuh untuk Anak-Anak"
              :value="detailAntrean.pemeriksaan_fisik.luas_fisik"
            />
            <InfoRow
              label="Kepala"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.kepala,
                  detailAntrean.pemeriksaan_fisik.ket_kepala
                )
              "
            />
            <InfoRow
              label="Mata"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.mata,
                  detailAntrean.pemeriksaan_fisik.ket_mata
                )
              "
            />
            <InfoRow
              label="Telinga"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.telinga,
                  detailAntrean.pemeriksaan_fisik.ket_telinga
                )
              "
            />
            <InfoRow
              label="Hidung"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.hidung,
                  detailAntrean.pemeriksaan_fisik.ket_hidung
                )
              "
            />
            <InfoRow
              label="Rambut"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.rambut,
                  detailAntrean.pemeriksaan_fisik.ket_rambut
                )
              "
            />
            <InfoRow
              label="Bibir"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.bibir,
                  detailAntrean.pemeriksaan_fisik.ket_bibir
                )
              "
            />
            <InfoRow
              label="Gigi Geligi"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.gigi_geligi,
                  detailAntrean.pemeriksaan_fisik.ket_gigi_geligi
                )
              "
            />
            <InfoRow
              label="Lidah"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.lidah,
                  detailAntrean.pemeriksaan_fisik.ket_lidah
                )
              "
            />
            <InfoRow
              label="Langit-Langit"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.langit_langit,
                  detailAntrean.pemeriksaan_fisik.ket_langit_langit
                )
              "
            />
            <InfoRow
              label="Leher"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.leher,
                  detailAntrean.pemeriksaan_fisik.ket_leher
                )
              "
            />
            <InfoRow
              label="Tenggorokan"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.tenggorokan,
                  detailAntrean.pemeriksaan_fisik.ket_tenggorokan
                )
              "
            />
            <InfoRow
              label="Tonsil"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.tonsil,
                  detailAntrean.pemeriksaan_fisik.ket_tonsil
                )
              "
            />
            <InfoRow
              label="Dada"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.dada,
                  detailAntrean.pemeriksaan_fisik.ket_dada
                )
              "
            />
            <InfoRow
              label="Payudara"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.payudara,
                  detailAntrean.pemeriksaan_fisik.ket_payudara
                )
              "
            />
            <InfoRow
              label="Punggung"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.punggung,
                  detailAntrean.pemeriksaan_fisik.ket_punggung
                )
              "
            />
            <InfoRow
              label="Perut"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.perut,
                  detailAntrean.pemeriksaan_fisik.ket_perut
                )
              "
            />
            <InfoRow
              label="Genital"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.genital,
                  detailAntrean.pemeriksaan_fisik.ket_genital
                )
              "
            />
            <InfoRow
              label="Anus/Dubur"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.anus,
                  detailAntrean.pemeriksaan_fisik.ket_anus
                )
              "
            />
            <InfoRow
              label="Lengan Atas"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.lengan_atas,
                  detailAntrean.pemeriksaan_fisik.ket_lengan_atas
                )
              "
            />
            <InfoRow
              label="Lengan Bawah"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.lengan_bawah,
                  detailAntrean.pemeriksaan_fisik.ket_lengan_bawah
                )
              "
            />
            <InfoRow
              label="Jari Tengah"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.jari_tangan,
                  detailAntrean.pemeriksaan_fisik.ket_jari_tangan
                )
              "
            />
            <InfoRow
              label="Kuku Tangan"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.kuku_tangan,
                  detailAntrean.pemeriksaan_fisik.ket_kuku_tangan
                )
              "
            />
            <InfoRow
              label="Persendian Tangan"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.persendian_tangan,
                  detailAntrean.pemeriksaan_fisik.ket_persendian_tangan
                )
              "
            />
            <InfoRow
              label="Tungkai Atas"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.tungkai_atas,
                  detailAntrean.pemeriksaan_fisik.ket_tungkai_atas
                )
              "
            />
            <InfoRow
              label="Tungkai Bawah"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.tungkai_bawah,
                  detailAntrean.pemeriksaan_fisik.ket_tungkai_bawah
                )
              "
            />
            <InfoRow
              label="Jari Kaki"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.jari_kaki,
                  detailAntrean.pemeriksaan_fisik.ket_jari_kaki
                )
              "
            />
            <InfoRow
              label="Kuku Kaki"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.kuku_kaki,
                  detailAntrean.pemeriksaan_fisik.ket_kuku_kaki
                )
              "
            />
            <InfoRow
              label="Persendian Kaki"
              :value="
                formatPemeriksaanFisik(
                  detailAntrean.pemeriksaan_fisik.persendian_kaki,
                  detailAntrean.pemeriksaan_fisik.ket_persendian_kaki
                )
              "
            />
          </b-collapse>
        </div>
        <div class="psikologis">
          <div
            class="row pointer"
            @click="visible_section_6 = !visible_section_6"
          >
            <div class="col-md font-weight-bold">
              Pemeriksaan Psikologis, Sosial Ekonomi, Spiritual
            </div>
            <div class="col-md text-right">
              <font-awesome-icon
                style="font-size: 24px;"
                :icon="['fas', 'chevron-down']"
                :class="{
                  'rotate-0': visible_section_6,
                  'rotate-90': !visible_section_6
                }"
              />
            </div>
          </div>
          <hr />
          <b-collapse
            id="accordion-6"
            v-model="visible_section_6"
            accordion="my-accordion"
            role="tabpanel"
          >
            <InfoRow
              label="Status Psikologis"
              :value="
                getStatusPsikologis(
                  detailAntrean.pemeriksaan_fisik.status_psikologis
                )
              "
            />
            <InfoRow
              label="Sosial Ekonomi"
              :value="detailAntrean.pemeriksaan_fisik.sosial_ekonomi"
            />
            <InfoRow
              label="Spiritual"
              :value="detailAntrean.pemeriksaan_fisik.spiritual"
            />
          </b-collapse>
        </div>
      </div>

      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right"
            @click="toggleDetailAntrean"
          >
            Tutup
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-form ref="refFormAlasan" style="display: none">
      <div class="row">
        <div class="col-md">
          <b-form-group>
            <b-form-textarea
              id="input-alasan"
              placeholder="Alasan"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <b-form-invalid-feedback id="input-1-live-feedback"
              >Wajib diisi</b-form-invalid-feedback
            >
          </b-form-group>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import moment from "moment";
import { VMoney } from "v-money";
import { mapGetters, mapState } from "vuex";
import "vue2-datepicker/index.css";
import debounce from "lodash/debounce";
import startCase from "lodash/startCase";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";
import {
  faArrowRight,
  faArrowUp,
  faTrashAlt,
  faSearch,
  faPencilAlt,
  faUpload,
  faDownload,
  faCopy,
  faClipboardList,
  faInfoCircle,
  faCalendar,
  faChevronDown,
  faInfo
} from "@fortawesome/free-solid-svg-icons";
moment.locale("id");

library.add(
  faChevronDown,
  faArrowRight,
  faDownload,
  faUpload,
  faArrowUp,
  faTrashAlt,
  faSearch,
  faPencilAlt,
  faCopy,
  faClipboardList,
  faInfoCircle,
  faCalendar,
  faInfo,
  farCircle
);

export default {
  components: {
    Multiselect: () => import("vue-multiselect"),
    "font-awesome-icon": FontAwesomeIcon,
    DataTableWrapper: () => import("../../components/DataTableWrapper"),
    "vue-select-clearable": () => import("@/components/VueSelectClearable.vue"),
    "v-select": () => import("@/components/VueSelect.vue"),
    DatePickerX: () => import("v-calendar/lib/components/date-picker.umd"),
    DatePicker: () => import("vue2-datepicker"),
    InfoRow: () => import("./components/InfoRow.vue")
  },
  directives: {
    money: VMoney
  },
  data() {
    return {
      customEntryOptions: { f: [5] },
      visible_section_6: false,
      visible_section_5: false,
      visible_section_4: false,
      visible_section_3: false,
      visible_section_2: true,
      visible_section_1: false,
      dataTanggal: null,
      selectedReschedulePoli: [],
      selectedDokter: [],
      selectedSlot: [],
      optionReschedulePoli: [],
      optionRescheduleDokter: [],
      optionSlot: [],
      validatePoli: false,
      validateSlot: false,
      validateDokter: false,
      transklinik_id: null,
      no_antrean: null,

      isTab: "today",
      tableShow: true,
      rowToday: 0,
      rowPrevDay: 0,
      rowNextDay: 0,

      optionKategori: [],
      optionKategoriPasien: [],
      optionDokter: [],
      optionStatus: ["Menunggu", "Konsultasi", "Selesai"],

      selectedKategori: null,
      selectedPoli: null,
      kategori_id: null,
      poli_id: null,
      dokter_id: null,
      date: null,
      status_id: "",

      searchValue: [],
      detailAntrean: null,
      showAllFilter: true,
      selectedFilter: "all",

      currentPage: 1,
      rows: 0,
      perPage: 10,
      antreanList: [],

      beingSubmit: false,
      errors: [],
      fromPage: 0,
      toPage: 0,
      totalEntries: 0,
      totalFilter: 0,
      sortBy: "",
      sortDesc: false,
      validationError: Object(),
      optionPoli: [],
      fieldList: [],
      customRow: {},
      kategoriPasien: null,
      isPoliGigi: false,
      alasanPembatalan: null,
      alergi: {
        udara: null,
        makanan: null,
        obat: null
      },
      pcareVersion: null,
      antrean: {
        total: 0,
        now: 0,
        next: 0,
        remaining: 0,
      },
      innerWidth: window.innerWidth,
    };
  },
  created() {
    this.setHeaderTable("today");
  },
  computed: {
    ...mapState(['sidebar']),
    ...mapGetters('sidebar', ['collapsed', 'orientation']),
    ...mapGetters([
      "getKlinikId",
      "getRolesName",
      "getDokterId",
      "satusehatAuthValid",
      "bpjsAuthValid",
      "bpjsConfig",
      "pemanggilanAntrean",
    ]),
    maxDate() {
      return moment()
        .add(2, "months")
        .toDate();
    }
  },
  watch: {
    dataTanggal: function(newVal, oldVal) {
      if (oldVal != null) {
        if (oldVal != newVal) {
          this.$nextTick(() => {
            this.selectedReschedulePoli = [];
            this.selectedDokter = [];
            this.selectedSlot = [];
          });
        }
      }
    },
    isTab() {
      //default filter
      (this.kategori_id = null),
        (this.poli_id = null),
        (this.dokter_id = null),
        (this.date = null),
        (this.status_id = "");

      this.setHeaderTable(this.isTab);
      this.tableShow = true;
      this.fetchListAntrean();
    },
    currentPage() {
      this.fetchListAntrean();
    },
    perPage() {
      this.fetchListAntrean();
    },
    sortBy() {
      this.fetchListAntrean();
    },
    sortDesc() {
      this.fetchListAntrean();
    },
    searchValue: {
      handler: "fetchListAntrean",
      deep: true
    },
    selectedKategori() {
      this.fetchListAntrean();
    },
    selectedPoli() {
      this.fetchListAntrean();
    },
    date() {
      this.fetchListAntrean();
    },
  },
  mounted() {
    // delete edit rekam medis
    this.deleteLocalStorage();
    this.isTab =
      this.$route.query.tab && this.$route.query.tab != undefined
        ? this.$route.query.tab
        : "today";
    this.getKategori();
    this.getKategoriPasien();
    this.getDokter();
    this.getPoli();
  },
  methods: {
    isMobilePortrait() {
      return this.isMobile() && this.orientation == 'portrait';
    },
    isScreenNoCollapsed() {
      return this.innerWidth < 1600 && !this.collapsed;
    },
    mediaInfoClass() {
      if (this.isMobilePortrait()) return 'mx-3 width-100';
      else if (this.isScreenNoCollapsed()) return 'ml-3';
      else return 'ml-3 media-info-wd';
    },
    panggilStatus(status) {
      if (this.checkValueData(status)) return ['batal', 'selesai'].includes(status.toLowerCase());
      return true;
    },
    async panggilAntrean(id, status) {
      if (this.panggilStatus(status)) return;
      
      try {
        const res = await this.$axios.get(
          `transaksi/panggil-antrean/${id}?klinik_id=${this.getKlinikId}`
        );
        const { status, message } = res.data;

        if (!status) {
          this.$swal({
            type: "error",
            text: message,
            confirmButtonText: startCase("OK"),
          });
        }
        this.fetchListAntrean();
      } catch (error) {}
    },
    formatPemeriksaanFisik(status, keterangan) {
      if (status == "N") {
        return "Tidak Diperiksa";
      }
      if (status == "T") {
        return "Tidak Ada Kelainan";
      }
      return keterangan;
    },
    getStatusPsikologis(status) {
      const statusMapping = {
        N: "Tidak Ada Kelainan",
        C: "Cemas",
        T: "Takut",
        M: "Marah",
        S: "Sedih",
        L: this.detailAntrean.pemeriksaan_fisik.ket_status_psikologis
      };

      return statusMapping[status] || "-";
    },
    onHiddenModalDetailHandler() {
      this.detailAntrean = null;
      this.visible_section_1 = false;
      this.visible_section_2 = true;
      this.visible_section_3 = false;
      this.visible_section_4 = false;
      this.visible_section_5 = false;
      this.visible_section_6 = false;
    },
    valueDiagnosa(label) {
      const opt = { Y: 'Ada', T: 'Tidak Ada' };
      let val = this.detailAntrean.diagnosa[label];
      if (this.checkValueData(val)) {
        if (label == 'penyakit_lainnya' && val == 'Y') {
          return `${opt[val] || '-'}, ${this.detailAntrean.diagnosa.ket_penyakit_lainnya || '-'}`
        }
        return opt[val] || '-';
      }
      return '-';
    },
    onlyDokter() {
      return (
        this.getRolesName.length == 1 &&
        this.getRolesName.includes("dokter_klinik")
      );
    },
    async rubahSchedule(id) {
      try {
        let dataPut = {
          klinik_id: this.getKlinikId,
          poli_id: this.selectedReschedulePoli.value,
          dokter_id: this.selectedDokter.value,
          slot: this.selectedSlot.value,
          no_antrean: this.no_antrean
        };

        const res = await this.$axios.put(
          `transaksi-reschedule/${id}`,
          dataPut
        );

        if (res.data.status) {
          this.$swal({
            text: res.data.message,
            type: "success",
            confirmButtonText: startCase("OK")
          }).then(res => {
            const { value } = res;
            if (value) {
              this.closeReschedule();
            }
          });
        } else if (!res.data.status) {
          this.$swal({
            text:
              "Maaf, slot waktu telah dipilih, silakan pilih slot waktu lainya!",
            type: "warning",
            confirmButtonText: startCase("OK")
          });
        }
      } catch (error) {}
    },
    onSubmitReschedule() {
      // jika kosong
      if (this.selectedReschedulePoli.length == 0) {
        this.validatePoli = true;
      } else {
        this.validatePoli = false;
      }

      if (this.selectedDokter.length == 0) {
        this.validateDokter = true;
      } else {
        this.validateDokter = false;
      }

      if (this.selectedSlot.length == 0) {
        this.validateSlot = true;
      } else {
        this.validateSlot = false;
      }

      if (
        this.selectedReschedulePoli.length != 0 &&
        this.selectedSlot.length != 0 &&
        this.selectedDokter.length != 0
      ) {
        this.rubahSchedule(this.transklinik_id);
      } else {
        return;
      }
    },

    inputPoliklinik(data) {
      this.validatePoli = false;

      this.$nextTick(() => {
        this.selectedDokter = [];
        this.selectedSlot = [];
      });

      this.getDokterReschedule(data.value, this.kategoriPasien);
    },
    inputDokter(data) {
      this.validateDokter = false;
      this.getSlot(
        data.value,
        this.selectedReschedulePoli.value,
        this.dataTanggal
      );
    },
    inputSlot(data) {
      this.no_antrean = data.no_urut;
      this.validateSlot = false;
    },
    async getDokterReschedule(id, kategori) {
      this.kategoriPasien = kategori;
      let cat = `&kategori=${kategori}`;
      try {
        const res = await this.$axios.get(
          `transaksi/list-dokter?klinik_id=${this.getKlinikId}&limit=50&poli_id=${id}${cat}`
        );
        const { data } = res.data;

        this.optionRescheduleDokter = data.map(item => {
          return {
            label: `${item.data.title}`,
            value: item.data.value,
            disable: item.disable
          };
        });
      } catch (error) {}
    },
    async getSlot(dokter_id, poli_id, tgl) {
      try {
        let date = moment(tgl).format("YYYY-MM-DD");
        const res = await this.$axios.get(
          `transaksi/antrean-slot?klinik_id=${this.getKlinikId}&limit=50&date=${date}&poli_id=${poli_id}&dokter_id=${dokter_id}&is_create=0`
        );
        const { data } = res.data;

        this.optionSlot = data;
      } catch (error) {}
    },
    formatLastModified(date) {
      return moment(date).format("MMM DD, YYYY @ HH:mm");
    },
    closeReschedule() {
      this.selectedSlot = [];
      this.selectedDokter = [];
      this.selectedReschedulePoli = [];
      this.dataTanggal = null;

      this.validateDokter = false;
      this.validateSlot = false;
      this.validatePoli = false;
      this.no_antrean = null;

      this.fetchListAntrean();
      this.$refs["my-modal-1"].hide();
    },
    async clickReschedule(id, nomor_antrian, kategori) {
      try {
        this.transklinik_id = id;
        this.no_antrean = nomor_antrian;

        const res = await this.$axios.get(
          `transaksi/${id}?klinik_id=${this.getKlinikId}`
        );
        const { data } = res.data;

        this.selectedReschedulePoli = {
          label: data.poli.nama,
          value: data.poli.id
        };
        this.selectedDokter = {
          label: data.dokter.nama,
          value: data.dokter.id
        };

        this.selectedSlot = data.slot_consultation;

        if (data.slot_consultation.value) {
          this.dataTanggal = moment(data.slot_consultation.value).toDate();
        } else {
          this.dataTanggal = moment(data.created_at).toDate();
        }

        this.getDokterReschedule(this.selectedReschedulePoli.value, kategori);
        if (data.dokter.nama) {
          this.getSlot(
            this.selectedDokter.value,
            this.selectedReschedulePoli.value,
            this.dataTanggal
          );
        }

        this.$refs["my-modal-1"].show();
      } catch (error) {}
    },
    async showDetailAntrean(dt) {
      try {
        const { success, data } = (
          await this.$axios.get(
            `transaksi/${dt.id}?klinik_id=${this.getKlinikId}`
          )
        ).data;
        if (success) {
          this.detailAntrean = data;
          if (!this.detailAntrean.pemeriksaan_fisik) {
            this.detailAntrean.pemeriksaan_fisik = {
              luas_fisik: null
            };
          }
          if (data.nama_kategori == 'BPJS' && this.bpjsAuthValid && this.bpjsConfig.pcare_version == '1') {
            this.pcareVersion = this.bpjsConfig.pcare_version;
            this.alergi = {
              makanan: data.anamnesa.riwayat_alergi_makanan,
              udara: data.anamnesa.riwayat_alergi_udara,
              obat: data.anamnesa.riwayat_alergi_obat,
            }
          }
          
          if (this.checkValueData(data.pasien)) this.detailAntrean.pekerjaan = data.pasien.pekerjaan && data.pasien.pekerjaan.includes('lain') ? data.pasien.ket_pekerjaan : data.pasien.pekerjaan;
          else detailAntrean.pekerjaan = null;

          this.isPoliGigi = this.checkPoliGigi(data.nama_poli);
          this.toggleDetailAntrean();
        }
      } catch (err) {
        // console.log(err);
      }
    },
    toggleDetailAntrean() {
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    pembatalanAntrean({ namaPasien = null, id, kategori } = {}) {
      this.$swal({
        title: startCase("pembatalan antrean"),
        text: `Apakah antrean pasien ${namaPasien} benar akan dibatalkan?`,
        type: "question",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        this.alasanPembatalan = "";
        const { value } = res;
        if (value) {
          this.$swal.close();
          const formElm = this.$refs.refFormAlasan.cloneNode(true);
          formElm.style.display = "block";
          const clonedInput = formElm.querySelector("#input-alasan");

          if (clonedInput) {
            clonedInput.value = this.alasanPembatalan;
            clonedInput.addEventListener("input", event => {
              clonedInput.classList.remove("is-invalid", "is-valid");
              if (event.target.value === "") {
                clonedInput.classList.add("is-invalid");
              } else {
                clonedInput.classList.add("is-valid");
              }
              this.alasanPembatalan = event.target.value;
            });
          }

          this.$swal({
            title: startCase("Alasan Pembatalan"),
            showCancelButton: true,
            cancelButtonText: startCase("batal"),
            confirmButtonText: startCase("simpan"),
            html: formElm,
            preConfirm: () => {
              if (!this.alasanPembatalan) {
                clonedInput.classList.add("is-invalid");
                return false;
              }
            }
          }).then(res => {
            if (res.value) {
              this.updateStatusAntrean("batal", id, this.alasanPembatalan);
            }
          });
          return;
        }
      });
    },
    async updateStatusAntrean(antreanStatus, id, alasan = "") {
      this.alasanPembatalan = "";
      try {
        const res = await this.$axios.post(
          `transaksi/delete/${id}?klinik_id=${this.getKlinikId}`,
          {
            alasan: alasan
          }
        );
        const { success, data, message } = res.data;
        if (success) {
          this.fetchListAntrean();
          this.$swal({
            type: "success",
            title: startCase("sukses hapus antrean"),
            text: `Antrean pasien sudah dibatalkan.`
          });
        } else {
          this.$swal({
            text: message,
            type: "warning"
          });
        }
      } catch (err) {
        // console.log(err);
      }
    },
    disabledDate(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return (
        date < today ||
        date >
          new Date(today.getFullYear(), today.getMonth() + 2, today.getDate())
      );
    },
    clearKategori(data) {
      if (data == null) {
        this.fetchListAntrean();
      }
    },
    clearPoli(data) {
      if (data.length == 0) {
        this.fetchListAntrean();
      }
    },
    setHeaderTable(type) {
      const {
        generateFieldList: g,
        setSearchableAndSortableFieldList: s
      } = this;
      const r = val =>
        Boolean(/(id|action|checklist|last_modified|panggil_antrean)\b/gi.test(val) ? !1 : 1);

      let field = [];
      if (type == "today" || type == "prev") {
        field = [
          {
            key: "slot",
            label: "slot konsultasi",
            thStyle: "min-width: 175px;"
          },
          {
            key: "nomor_urut_bpjs",
            label: "no. urut",
            thStyle: "min-width: 125px;"
          },
          {
            key: "nomor_rekam_medis",
            label: "no.rekam medis",
            thStyle: "min-width: 175px;"
          },
          {
            key: "nama_pasien",
            label: "nama pasien",
            thStyle: "min-width: 300px;"
          },
          {
            key: "nama_poli",
            label: "Poliklinik",
            thStyle: "min-width: 175px;"
          },
          {
            key: "nama_dokter",
            label: "Dokter",
            thStyle: "min-width: 250px;"
          },
          {
            key: "nama_kategori",
            label: "kategori",
            thStyle: "min-width: 125px;"
          },
          {
            key: "nama_sumber",
            label: "Sumber",
            thStyle: "min-width: 150px;"
          },
          {
            key: "status",
            label: "status pasien",
            thStyle: "min-width: 175px;"
          },
          {
            key: "action",
            label: "actions",
            thStyle: "min-width: 100px;"
          },
          {
            key: "last_modified",
            label: "last modified",
            thStyle: "min-width:200px;"
          },
        ];
        
        if (type == 'today' && this.hasFeatures('edit_rm') && this.checkValueData(this.pemanggilanAntrean)) {
          field = [...field, ...[{
            key: "panggil_antrean",
            label: "panggil antrean",
            thStyle: "min-width: 100px;",
            thClass: "sticky-column-antrean",
            tdClass: "sticky-column-antrean p-0",
            stickyColumn: true,
          }]];
        } else if (type == "prev") {
          field.unshift({
            key: "waktu_konsultasi",
            label: "hari, tanggal",
            thStyle: "min-width: 200px;"
          });

          const keysDel = [];
          field.forEach((el, idx) => {
            if (["nomor_antrian", "status"].includes(el.key)) {
              keysDel.push(idx);
            }
          });
          field = field.filter((el, idx) => !keysDel.includes(idx));
        }
      } else {
        field = [
          {
            key: "waktu_konsultasi",
            label: "hari, tanggal",
            thStyle: "min-width: 200px;"
          },
          {
            key: "slot",
            label: "slot konsultasi",
            thStyle: "min-width: 175px;"
          },
          {
            key: "nomor_rekam_medis",
            label: "no.rekam medis",
            thStyle: "min-width: 175px;"
          },
          {
            key: "nama_pasien",
            label: "nama pasien",
            thStyle: "min-width: 300px;"
          },
          {
            key: "nama_poli",
            label: "Poliklinik",
            thStyle: "min-width: 175px;"
          },
          {
            key: "nama_dokter",
            label: "Dokter",
            thStyle: "min-width: 250px;"
          },
          {
            key: "nama_kategori",
            label: "kategori",
            thStyle: "min-width: 125px;"
          },
          {
            key: "nama_sumber",
            label: "Sumber",
            thStyle: "min-width: 150px;"
          },
          {
            key: "action",
            label: "actions",
            thStyle: "min-width: 100px;"
          },
          {
            key: "last_modified",
            label: "last modified",
            thStyle: "min-width: 200px;"
          }
        ];
      }

      this.fieldList =
        field
        |> (v => s({ field: v, customFunc: r }))
        |> (z => g({ field: z }));
    },
    hasTodayAction(status, action) {
      const opt = {
        menunggu: {
          edit_detail_antrean: ["pic_cabang", "frontdesk", "kasir", "perawat"],
          detail_registrasi_antrean: [
            "pic_cabang",
            "dokter_klinik",
            "perawat",
            "apoteker",
            "frontdesk",
            "kasir"
          ],
          batal_konsultasi: ["pic_cabang", "frontdesk", "kasir"],
          reschedule: ["pic_cabang", "frontdesk", "kasir"],
          tulis_rm: ["dokter_praktek", "dokter_klinik"],
          lihat_rm: ["dokter_klinik", "pic_cabang", "apoteker", "perawat"],
        },
        konsultasi: {
          detail_registrasi_antrean: [
            "pic_cabang",
            "dokter_klinik",
            "perawat",
            "apoteker",
            "frontdesk",
            "kasir"
          ],
          reschedule: ["pic_cabang", "frontdesk", "kasir"],
          lihat_rm: ["dokter_klinik", "pic_cabang", "apoteker", "perawat"],
          edit_rm: ["dokter_praktek", "dokter_klinik"],
        },
        selesai: {
          detail_registrasi_antrean: [
            "pic_cabang",
            "dokter_klinik",
            "perawat",
            "apoteker",
            "frontdesk",
            "kasir"
          ],
          edit_rm: ["dokter_praktek", "dokter_klinik"],
          lihat_rm: ["dokter_klinik", "pic_cabang", "apoteker", "perawat"],
        }
      };

      if (!opt[status.toLowerCase()].hasOwnProperty(action)) return false;

      const isOwner = opt[status.toLowerCase()][action].filter(feature => {
        return this.getRolesName.includes(feature);
      });

      return isOwner.length > 0 ? true : false;
    },
    hasNextAction(value) {
      if (this.isTab == "prev" && value == "reschedule") {
        return false;
      }

      const features = {
        edit_detail_antrean: ["pic_cabang", "frontdesk", "kasir", "perawat"],
        detail_registrasi_antrean: [
          "pic_cabang",
          "dokter_klinik",
          "perawat",
          "apoteker",
          "frontdesk",
          "kasir"
        ],
        batal_konsultasi: ["pic_cabang", "frontdesk", "kasir"],
        reschedule: ["pic_cabang", "frontdesk", "kasir"],
        lihat_rm: ["dokter_klinik", "pic_cabang", "apoteker", "perawat"]
      };

      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return isOwner.length > 0 ? true : false;
    },
    hasFeatures(value) {
      const features = {
        tambah_antrean: ["pic_cabang", "frontdesk", "kasir"],
        edit_antrean: ["pic_cabang", "frontdesk", "kasir", "perawat"],
        delete_antrean: ["pic_cabang", "frontdesk", "kasir"],
        reschedule_antrean: ["pic_cabang", "frontdesk", "kasir"],
        lihat_rm: ["dokter_klinik", "pic_cabang", "apoteker", "perawat"],
        tulis_rm: ["dokter_praktek", "dokter_klinik"],
        edit_rm: ["dokter_praktek", "dokter_klinik"],
      };

      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return isOwner.length > 0 ? true : false;
    },
    async getPoli() {
      try {
        const res = await this.$axios.get(
          `layanan/poli?klinik_id=${this.getKlinikId}`
        );
        const { data, status } = res.data;
        if (status) {
          this.optionPoli = data.map(res => ({
            ...res,
            label: res.nama,
            value: res.id
          }));

          this.optionReschedulePoli = this.optionPoli;
        }
      } catch (error) {}
    },
    async getKategori() {
      try {
        const res = await this.$axios.get(
          `layanan/kategori?klinik_id=${this.getKlinikId}`
        );
        const { data, status } = res.data;
        if (status) {
          this.optionKategori = data.map(res => ({
            ...res,
            label: res.nama,
            value: res.id
          }));
        }
      } catch (error) {}
    },
    async getKategoriPasien() {
      try {
        const res = await this.$axios.get(
          `kategori-pasien?klinik_id=${this.getKlinikId}`
        );
        const { data, status } = res.data;
        if (status) {
          this.optionKategoriPasien = data.map(res => ({
            ...res,
            label: res.nama,
            value: res.id
          }));
        }
      } catch (error) {}
    },
    async getDokter() {
      try {
        const res = await this.$axios.get(
          `transaksi/list-dokter?klinik_id=${this.getKlinikId}&limit=50&poli_id=${this.poli_id.value}`
        );
        const { data, status } = res.data;

        if (status) {
          this.optionDokter = data.reduce((result, item) => {
            if (item.data.title !== "LAINNYA") {
              let opt = {
                label: item.data.title,
                value: item.data.value
              };
              result.push(opt);
            }
            return result;
          }, []);
        }
      } catch (error) {}
    },

    handleValueChanged({ perPage, currentPage }) {
      perPage && (perPage |> (_ => (this.perPage = _)));
      currentPage && (currentPage |> (_ => (this.currentPage = _)));
    },
    searchValueChanged: debounce(function(val, key) {
      const { searchValue } = this;

      const z = searchValue.filter(item => item.key !== key);

      this.searchValue = [
        ...z,
        {
          key,
          value: val
        }
      ];
    }, 500),

    determineParameter() {
      const { searchValue, sortBy, sortDesc } = this;
      let v = "";

      if (this.selectedKategori != null) {
        v += `&nama_kategori=${this.selectedKategori.value}`;
      }

      if (this.selectedPoli != null) {
        v += `&nama_poli=${this.selectedPoli.value}`;
      }

      searchValue.map(item => {
        const x = item.key;
        v += `&${x}=${item.value}`;
      });

      if (sortBy) {
        v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
      }

      return v;
    },
    additionalFilter(val) {
      if (val == "poli") {
        this.getDokter();
        if (this.poli_id == null) {
          this.kategori_id = null;
          this.poli_id = null;
          this.dokter_id = null;
          this.status_id = null;
        }
      }
      this.fetchListAntrean();
    },
    formatAdditionalFilter() {
      const { date, poli_id, dokter_id, kategori_id, status_id } = this;
      let filter =
        this.isTab == "today"
          ? {
              poli_id,
              dokter_id,
              kategori_id,
              status_id
            }
          : {
              date,
              poli_id,
              dokter_id,
              kategori_id
            };

      if (date === null) delete filter.date;

      let __this = this;
      let param = Object.keys(filter).reduce(function(carry, key) {
        let id;

        if (key == "date") {
          id = moment(filter[key]).format("YYYY-MM-DD");
        } else if (key == "dokter_id" && __this.onlyDokter()) {
          id = __this.getDokterId;
        } else if (key == "status_id") id = filter[key];
        else id = filter[key] == null ? "" : filter[key]["value"];

        return (carry += `&${key}=${id || ""}`);
      }, "");
      return param;
    },
    async fetchListAntrean() {
      try {
        const res = await this.$axios.get(
          `transaksi?klinik_id=${this.getKlinikId}&tab=${
            this.isTab
          }&limit=${this.perPage}&page=${
            this.currentPage
          }${this.determineParameter()}${this.formatAdditionalFilter()}`
        );

        const { success, data } = res.data;

        if (success) {
          const {
            today: amountToday,
            prev: amountPrev,
            next: amountNext,
          } = data.amount;

          this.rowToday = amountToday;
          this.rowPrevDay = amountPrev;
          this.rowNextDay = amountNext;

          const {
            total: antreanTotal,
            now: antrean,
            next: nextAntrean,
            remaining: remainingAntrean,
          } = data.antrean;

          this.antrean.total = antreanTotal;
          this.antrean.now = antrean;
          this.antrean.next = nextAntrean;
          this.antrean.remaining = remainingAntrean;

          const {
            data: antreanData,
            total: totalEntries,
            to: toPage,
            from: fromPage
          } = data.trans_klinik;

          this.antreanList = antreanData;
          this.totalFilter = antreanData.length;

          this.rows = totalEntries || 0;
          this.toPage = toPage || 1;
          this.fromPage = fromPage || 1;
          this.totalEntries = totalEntries || 0;

          this.customRow = {
            rows: totalEntries || 0,
            toPage: toPage || 1,
            fromPage: fromPage || 1,
            totalEntries: totalEntries || 0
          };

          return this;
        }
      } catch (err) {}
    },

    async goToRekamMedis(data, type) {
      if(type == 'tulis_rm'){
        let adaPaket = await this.cekPaket();
        if(!adaPaket){
          return false;
        }
      }
      
      localStorage.setItem("with_parent", 1);
      localStorage.setItem("poli_id", data.poli_id);
      localStorage.setItem("edit_rm", 0);
      if (type == "edit_rm" && data.rekam_medis_id != null) {
        localStorage.setItem("rekam_medis_id", data.rekam_medis_id);
        localStorage.setItem("rm_reload", true);
        localStorage.setItem("edit_rm", 1);
      }

      if (data.nama_kategori == "BPJS") {
        const res = await this.$axios.put(
          `transaksi/hit-bpjs/${data.id}?klinik_id=${this.getKlinikId}`
        );

        const { status, message } = res.data;

        if (!status) {
          this.$swal({
            title: `Data pendaftaran BPJS Gagal Diproses`,
            html: message,
            type: "success",
            showCancelButton: true,
            cancelButtonText: "Lanjutkan",
            confirmButtonText: "Coba Lagi",
            cancelButtonColor: "#1bc943",
            allowOutsideClick: false
          }).then(res => {
            if (res.value) {
              this.goToRekamMedis(data, type);
            } else {
              this.$router.push(
                `/klinik/rekam-medis/${data.id}/${data.pasien_id}`
              );
            }
          });
          return;
        }
      }
      this.$router.push(`/klinik/rekam-medis/${data.id}/${data.pasien_id}`);
    },
    async goToRiwayatRekamMedis(pasien_id) {
      if (pasien_id) {
        let withParentQS = "";
        withParentQS = "&with_parent=1";
        const res = await this.$axios.get(`pasien/${pasien_id}?klinik_id=${this.getKlinikId}&id=${pasien_id}${withParentQS}`);
        const { status, data, data_rm, own_rm } = res.data;
        if (!status || !data_rm || !own_rm) {
          if (!data || data.nama != undefined) {
            this.goNotFound();
            return;
          }

          this.$swal({
            type: "error",
            title: startCase("Gagal"),
            text: startCase(`Pasien ${data.nama} belum memiliki rekam medis!`),
          }).then(res => {
            this.kembali();
          });
          return;
        } else {
          localStorage.setItem("rekam_medis", window.location.pathname);
          this.$router.push({
            name: "klinik-rekam-medis-riwayat",
            params: {
              pasien_id: pasien_id
            }
          });
        }
      }
    },
    deleteLocalStorage() {
      localStorage.removeItem("poli_id");
      localStorage.removeItem("rekam_medis_id");
      localStorage.removeItem("edit_rekam_medis");
      localStorage.removeItem("rm_reload");
    },
    checkSyncSatuSehat(data) {
      let result = null;
      if (this.satusehatAuthValid) {
        if (data.synced_to_satusehat == 3) result = 'skip sync';
        else if (
          data.synced_to_satusehat == 1 &&
          data.satusehat_encounter_id != "" &&
          data.satusehat_encounter_id != null
        )
          result = "success";
        else if (
          (data.synced_to_satusehat == 2 || data.synced_to_satusehat == 1) &&
          (data.satusehat_encounter_id == "" ||
            data.satusehat_encounter_id == null)
        )
          result = "failed";
      }
      return result;
    },
    async syncSatuSehat(item) {
      let type = '', error = false, msg = '',
        satusehat = {status: false, message: ''},
        bpjs = {status: false, message: ''};

      if (this.satusehatAuthValid && item.synced_to_satusehat != 1) {
        type += 'satusehat';
        const res_satusehat = await this.$axios.put(
          `satu-sehat/transklinik/sync/${item.id}?klinik_id=${this.getKlinikId}`
        );
        satusehat = {
          status: res_satusehat.data.status,
          message: res_satusehat.data.message
        }
      }
      
      if (this.bpjsAuthValid && item.kategori_id == 2 && [2, 5].includes(item.synced_to_bpjs)) {
        type += 'bpjs';
        const res_bpjs = await this.$axios.put(
          `bpjs/sync_add_pendaftaran/${item.id}?klinik_id=${this.getKlinikId}`
        );
        bpjs = {
          status: res_bpjs.data.status,
          message: res_bpjs.data.message
        }
      }

      if (type == 'satusehatbpjs') {
        msg = `${satusehat.message}<br><hr>${bpjs.message}`;
        if (!satusehat.status || !bpjs.status) error = true;
      } else if (type == 'satusehat') {
        msg = satusehat.message;
        if (!satusehat.status) error = true;
      } else if (type == 'bpjs') {
        msg = bpjs.message;
        if (!bpjs.status) error = true;
      } else {
        error = true;
        msg = 'Terjadi Kesalahan';
      }

      if (error) {
        this.$swal({
          html: msg,
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Tutup",
          confirmButtonText: "Coba Lagi",
          cancelButtonColor: "#1bc943",
          allowOutsideClick: false
        }).then(async res => {
          if (res.value && item) {
            await this.syncSatuSehat(item);
          } else {
            await this.fetchListAntrean();
          }
        });
        return;
      }

      this.$swal({
        html: msg,
        type: "success",
        confirmButtonText: "OK"
      }).then(async res => {
        if (res.value) {
          await this.fetchListAntrean();
        }
      });
    },
    async cetakNomorAntrean(id) {
      try {
        const response = await this.$axios.get(
          `transaksi/cetak-nomor/${id}`
        );

        // Open the print window
        const WinPrint = window.open(
          "",
          "",
          "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
        );

        // Add a style tag to remove margins
        const style = `
          <style>
            @page { 
              size: auto;  /* auto is the current printer page size */
              margin: 0mm;  /* this affects the margin in the printer settings */
            }
            body { 
              margin: 0;  /* this affects the margin in the content */
            }
          </style>
        `;

        // Write the response data and the style to the new window
        WinPrint.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>Print</title>
            ${style}
          </head>
          <body>
            ${response.data}
          </body>
          </html>
        `);

        window.setTimeout(() => {
          WinPrint.focus();
          WinPrint.print();
        }, 200);
      } catch (error) {
      }
    },
    checkLain(type) {
      if (this.pcareVersion == '1' && this.alergi[type]) {
        if (this.alergi[type].toLowerCase().includes('lain')) return true;
      }
      return false;
    },
    bpjsTooltipInvalidMessage(status) {
      if (status == 2) return "Data kunjungan BPJS gagal di proses";
      if (status == 3) return "Data panggil antrean BPJS gagal di proses";
      if (status == 4) return "Data pendaftaran BPJS gagal di proses";
      if (status == 5) return "Data pendaftaran dan kunjungan BPJS gagal di proses";
      return "Data BPJS gagal di proses"
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect {
  &.__multi-select-tarif {
    min-height: auto !important;
    font-size: 12px !important;
    height: 31px !important;
    & > .multiselect__select {
      margin-top: -6px;
    }
    & > .multiselect__tags {
      height: 31px !important;
      min-height: 31px !important;
      padding: 2px 30px 0 6px;
    }
  }
}
.multiselect {
  &.custom-v-select-manajemen-antrean {
    height: 30px !important;
  }
}

.modal-backdrop {
  opacity: 0.5 !important;
}
.modal_detail_antrean .modal-header {
  background-color: #4896e8;
  color: white;
}

.modal_detail_antrean > header > button.close {
  float: right;
  font-size: 1.425rem;
  font-weight: 700;
  line-height: 1;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  color: white;
}

.modal_detail_antrean .modal-body {
  background-color: #fff;
}

.modal_detail_antrean .modal-footer {
  background-color: #fff;
}

.izd-datatable-tarif {
  height: auto !important;
}
</style>

<style lang="css">
.rotate-0 {
  transform: rotate(0deg);
  transition: transform 0.3s ease; /* You can adjust the duration and timing function as needed */
}

.rotate-90 {
  transform: rotate(-90deg);
  transition: transform 0.3s ease; /* You can adjust the duration and timing function as needed */
}
.bg-kuning {
  background: #f7fc6b;
}

#kodetarif {
  text-transform: uppercase;
}

.modal fade show {
  opacity: 0.9;
}

.error {
  color: red;
}

.bg-kuning,
.bg-danger,
.bg-first {
  color: black !important;
}

.no-padding {
  padding: 0 !important;
}

.page-item.active a {
  background: #3b86ff;
  border: none !important;
}

.layout-gantung {
  border-radius: 0px 0px 10px 10px;
  max-height: 250px;
}

.ninja-shadow {
  box-shadow: 0px 8px 15px 0px lightgrey;
}

table thead tr.text-capitalize th {
  background: #dcecec;
}

table tbody tr.ganjil td {
  background: #f2f5f5;
}

table tbody tr.genap td {
  background: #e5ebea;
}

.btn-today,
.btn-next {
  font-size: 12pt;
  border: 2px solid #cdcdcd;
  font-weight: 700;
}

.btn-today:hover,
.btn-next:hover {
  box-shadow: none !important;
  border: 2px solid #cdcdcd;
  background-color: #ffffff;
  color: #134aae;
}

.btn-today {
  border-radius: 10px 0 0 10px;
}

.btn-next {
  border-radius: 0 10px 10px 0;
}

.active__time,
.active__time:hover,
.btn-today:focus,
.btn-next:focus {
  background-color: #6ed0f67d !important;
  color: #134aae !important;
}

.desc-antrean {
  margin-top: 20px;
  font-size: 16pt;
  font-weight: 700;
}

.lb-total {
  color: #0440a0;
}

.nb-total {
  color: #555c5c;
}

.stright-line,
.stright-line-none {
  background-color: #86b8ed;
  height: 2px;
  margin: 20px 0;
}

.stright-line-none {
  background-color: transparent;
}

.__card-blue {
  width: 100%;
  border-radius: 8px;
  background-color: #243ee9;
}

.__card-green {
  width: 100%;
  border-radius: 8px;
  background-color: #009463;
}

.__card-coklat {
  width: 100%;
  border-radius: 8px;
  background-color: #d5720e;
}

.__card-red {
  width: 100%;
  border-radius: 8px;
  background-color: #f40808;
}

/* width */
#antrean-table::-webkit-scrollbar {
  width: 5px;
}

/* Track */
#antrean-table::-webkit-scrollbar-track {
  box-shadow: inset 0 0 1px grey;
  border-radius: 10px;
}

/* Handle */
#antrean-table::-webkit-scrollbar-thumb {
  background: #cdcdcd;
  border-radius: 10px;
}

/* Handle on hover */
#antrean-table::-webkit-scrollbar-thumb:hover {
  background: #cdcdcd;
}

@media only screen and (max-width: 1550px) and (min-width: 1280px) {
  body {
    overflow-x: hidden;
  }
  ::-webkit-scrollbar {
    width: initial;
  }

  #antrean-table {
    max-width: 100% !important;
  }
}

@media screen and (min-width: 1551px) {
  body {
    overflow-x: visible;
  }

  body::-webkit-scrollbar-track {
    box-shadow: inset 0 0 1px grey;
    border-radius: 10px;
  }

  body::-webkit-scrollbar-thumb {
    background: #cdcdcd;
    border-radius: 10px;
  }

  #antrean-table {
    max-width: 100% !important;
  }
}

.info-tooltip,
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: rgb(18, 106, 207);
  color: white;
  border-radius: 5px;
  padding: 5px 10px 4px;
  box-shadow: 0px 0px 0px rgba(black, 0.1) !important;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: rgb(18, 106, 207);
  z-index: 1;
}

.info-tooltip .tooltip-inner {
  background: #ffffff !important;
  color: #858585 !important;
  max-width: 400px !important;
  width: 400px !important;
  text-align: left !important;
  border-radius: 5px;
  padding: 5px 10px 4px;
  box-shadow: 0px 0px 0px rgba(black, 0.1) !important;
}

.info-tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #ffffff;
  z-index: 1;
}

.satusehat-tooltip .tooltip-inner {
  background: #ffffff !important;
  color: #858585 !important;
}

.satusehat-tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #ffffff;
  z-index: 1;
}

.mx-datepicker .mx-input {
  height: 41.7px !important;
}

.time-dimention button {
  font-size: 11pt !important;
}

@media screen and (max-width: 1380px) {
  .sticky-header-antrean {
    width: 135%;
  }
}

.sticky-header-antrean th {
  position: -webkit-sticky;
  position: sticky;
  top: -2px;
  z-index: 1;
}

.__zoom_display_antrean {
  transform: scale(0.81);
  width: 128%;
  margin-left: -14%;
  margin-top: -10% !important;
}

@media screen and (max-width: 768px) {
  .__zoom_display_antrean {
    transform: scale(0.81);
    width: 128%;
    margin-left: -14%;
    margin-top: -1% !important;
  }
}

.select-status {
  margin-top: 7px;
  height: 30px;
  font-size: 11pt;
  padding: 0;
}
.select-status option {
  font-size: 9pt;
}
.icon_sync_satusehat {
  width: 35px;
  padding: 5px;
  font-size: 2.3em;
  margin-top: -5px;
  cursor: pointer;
}

.icon_sync_bpjs {
  width: 35px;
  margin-top: -3px;
  cursor: pointer;
}

.color-info {
  color: #3772d7;
}

.media-info {
  padding: 10px;
  margin-top: 1rem;
  border-radius: 7px;
  border: 1px solid #ddd;
}

.media-info-wd {
  width: 250px;
}

.width-100 {
  width: 100% !important;
}

.fc-jumlah-antrean {
  color: #D37222;
}

.fc-antrean-sekarang {
  color: #05C52F;
}

.fc-antrean-selanjutnya {
  color: #1484C9;
}

.fc-sisa-antrean {
  color: #392196;
}

.sticky-column-antrean {
  position: -webkit-sticky !important;
  position: sticky !important;
  right: 0 !important;
  z-index: 1 !important;
  background: linear-gradient(to right, #dcdef1 2%, #ffffff 2%);
}

.borderleft {
  padding-top: 1rem;
  padding-bottom: 1.2rem;
}

.btn-panggil {
  border-color: #0EDB1C;
  background-color: #0EDB1C;
}

.btn-selesai-panggil {
  cursor: not-allowed !important;
  border-color: #D7D7D7;
  background-color: #D7D7D7;
}

.rounded-50 {
  border-radius: 50%;
}

.fs-7-5 {
  font-size: 0.75rem;
}
</style>
